import React, { useEffect, useState } from "react";
import axios from "axios";
import "../CustomWeatherWidget.css";
import FaisalabadForcastWeahter from "../fsdForeCastOpenWeather";
import { ThemeProvider, createTheme, useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import LogOutDropDown from "../../LogOut/logOutDropDown";
import { useNavigate, useLocation } from "react-router-dom";
import WbSunnyIcon from "@mui/icons-material/WbSunny";
import MapLoader from "../../All-Loader/mapLoader";

import {
  ArrowBackIos as ArrowBackIosIcon,
  Menu as MenuIcon,
  Home as HomeIcon,
  Info as InfoIcon,
  ContactMail as ContactMailIcon,
  Settings as SettingsIcon,
  Person as PersonIcon,
  Dashboard as DashboardIcon,
} from "@mui/icons-material";

import {
  Drawer,
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemButton,
  Divider,
  ListItemText,
  IconButton,
  Menu,
  MenuItem,
} from "@mui/material";
import { useMediaQuery } from "@mui/material";
import {
  ExpandLess,
  ExpandMore,
  ArrowBack as ArrowBackIcon,
} from "@mui/icons-material";
import LanguageSwitcher from "../../Language-Switcher/languageSwitcher";
import Feedback from "../../Feedback/feedback";
import { Tooltip, styled } from "@mui/material";
import KisanLogo from "../../Assets/Logo/kisan-bg.png";

const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme, isRtl }) => ({
  [`& .MuiTooltip-tooltip`]: {
    backgroundColor: "black",
    color: "white",
    fontSize: isRtl ? 15 : 12, // Set fontSize based on RTL or LTR
  },
}));

const WeatherWidget = () => {
  const [weatherData, setWeatherData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { t, i18n } = useTranslation();
  const isRtl = i18n.dir() === "rtl";
  const navigate = useNavigate();
  const location = useLocation(); // Get the current path
  const city = "Faisalabad";
  const apiKey = "4a1da579331826fb650783766abc4ec2";

  useEffect(() => {
    const fetchWeather = async () => {
      setLoading(true);
      setError(null);

      // Simulate a delay before fetching data
      setTimeout(async () => {
        try {
          const response = await axios.get(
            `https://api.openweathermap.org/data/2.5/forecast?q=${city}&appid=${apiKey}&units=metric`
          );
          setWeatherData(response.data);
        } catch (err) {
          setError(err);
        }
        setLoading(false);
      }, 2500); // 2-second delay
    };

    fetchWeather();
  }, []);

  const menuItems = [
    {
      text: "Weather Forecast",
      icon: <WbSunnyIcon />,
      link: "/WeatherForecast",
    },
    { text: "CAS Faisalabad", icon: <WbSunnyIcon />, link: "/CASFaisalabad" },
    { text: "Burewala", icon: <WbSunnyIcon />, link: "/BurewalaWeather" },
    { text: "Okara", icon: <WbSunnyIcon />, link: "/OkaraWeather" },
    { text: "Toba Campus", icon: <WbSunnyIcon />, link: "/TobaCampusWeather" },
    // {
    //   text: "Faisalabad 2",
    //   icon: <WbSunnyIcon />,
    //   link: "/DevisVantageWeather",
    // },
  ];
  const darkModeTheme = createTheme({
    palette: {
      mode: "dark",
      background: {
        default: "#212930",
      },
      text: {
        primary: "#9fb4c7",
      },
    },
  });

  //// SideDrawer polygone
  const theme = useTheme(); // Access the theme object
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("lg")); // Use the theme object with useMediaQuery
  const [open, setOpen] = useState(isLargeScreen);

  useEffect(() => {
    setOpen(isLargeScreen);
  }, [isLargeScreen]);

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [dropdownVisible, setDropdownVisible] = useState(null);

  const handleMenuOpen = (event, id) => {
    setAnchorEl(event.currentTarget);
    setDropdownVisible(id);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setDropdownVisible(null);
  };

  const handleDrawerToggle = () => {
    setOpen(!open);
    setDropdownOpen(false);
  };

  if (loading) return <MapLoader />;
  if (error) return <p>Error fetching data: {error.message}</p>;

  const handleGoBack = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      navigate("/"); // Navigate to the home page
    }, 2500); // Set a delay before navigation
  };

  const getDayOfWeek = (dateString) => {
    const date = new Date(dateString);
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    return days[date.getDay()];
  };
  const getWindDirection = (degrees) => {
    const directions = ['N', 'NNE', 'NE', 'ENE', 'E', 'ESE', 'SE', 'SSE', 'S', 'SSW', 'SW', 'WSW', 'W', 'WNW', 'NW', 'NNW'];
    const index = Math.round(degrees / 22.5) % 16;
    return directions[index];
  };
  return (
        <div>
          <ThemeProvider theme={darkModeTheme}>
            <div style={{ display: "flex", height: "100vh" }}>
              {/* --- The Sidebar is identical and requires no changes --- */}
              <Drawer
                variant="permanent"
                open={open}
                PaperProps={{
                  sx: {
                    backgroundColor: "#212930", color: "#9fb4c7", width: open ? 250 : 60,
                    transition: "width 0.3s", overflowX: "hidden", position: "relative",
                    display: "flex", flexDirection: "column",
                  },
                }}
              >
                <Box sx={{ flexGrow: 1, overflowY: "auto", overflowX: "hidden", maxHeight: "calc(100vh)" }}>
                  <Box sx={{ display: "flex", alignItems: "center", padding: "8px", justifyContent: open ? "space-between" : "center" }}>
                    <IconButton onClick={handleDrawerToggle} sx={{ color: "#9fb4c7" }}>
                      {open ? <ArrowBackIosIcon /> : <MenuIcon />}
                    </IconButton>
                    {open && <img src={KisanLogo} alt="logo" width={120} />}
                  </Box>
                  <Divider sx={{ backgroundColor: "#555" }} />
                  <Box sx={{ display: "flex", alignItems: "center", cursor: "pointer", padding: "8px", justifyContent: "center", height: "60px", backgroundColor: "transparent" }} onClick={handleGoBack}>
                    <CustomTooltip title="Back to Home" placement="right">
                      <IconButton>
                        <HomeIcon sx={{ color: "#004ba1", fontSize: "2rem", background: "white", padding: "3px", borderRadius: "10px 0px 10px 0px" }} />
                      </IconButton>
                    </CustomTooltip>
                  </Box>
                  <List>
                    {menuItems.map((item, index) => (
                      <ListItem key={index} disablePadding sx={{ display: "block" }}>
                        <CustomTooltip title={item.text} placement="right">
                          <ListItemButton sx={{ minHeight: 48, justifyContent: open ? "initial" : "center", px: 2.5, borderRight: location.pathname === item.link ? "4px solid #004ba1" : "none", backgroundColor: location.pathname === item.link ? "#2e3b4a" : "transparent" }} onClick={() => navigate(item.link)}>
                            <ListItemIcon sx={{ minWidth: 0, mr: open ? 3 : "auto", justifyContent: "center", minHeight: open ? "0px" : "50px", color: "#9fb4c7", alignItems: "center" }}>
                              {item.icon}
                            </ListItemIcon>
                            <ListItemText primary={item.text} sx={{ opacity: open ? 1 : 0 }} />
                          </ListItemButton>
                        </CustomTooltip>
                      </ListItem>
                    ))}
                  </List>
                </Box>
                <Box sx={{ position: "relative" }}>
                  <Divider sx={{ backgroundColor: "#555" }} />
                  <Box sx={{ padding: open ? "10px" : "5px", display: "flex", flexDirection: open ? "row" : "column", alignItems: "center", Content: "center", gap: open ? "0px" : "5px", marginLeft: open ? "-20px" : "0px", ...(isRtl ? { marginRight: "0px" } : { marginRight: "30px" }), bottom: 0, width: open ? 260 : 60, backgroundColor: "#212930" }}>
                    <div><LogOutDropDown /></div>
                    <div style={{ marginRight: open ? (isRtl ? "0" : "30px") : "0", marginLeft: open ? (isRtl ? "20px" : "0") : "0" }}>
                      <LanguageSwitcher />
                    </div>
                    <div><Feedback /></div>
                  </Box>
                </Box>
              </Drawer>
    
              {/* --- START: REFACTORED MAIN CONTENT (UI ONLY) --- */}
              <Box
                component="main"
                sx={{
                  flexGrow: 1, bgcolor: "#212930", overflowY: "auto",
                  maxHeight: "calc(100vh)", padding: 0, display: "flex",
                  flexDirection: "column", justifyContent: "space-between",
                }}
              >
                <header className="weather-widget-header">
                  <div style={{ padding: "10px" }}>
                    <div className="d-flex justify-content-center mt-4">
                      <h3 style={{ margin: "0 10px", color: "#9fb4c7", fontWeight: "bold", display: "flex", justifyContent: "center", textAlign: "justify" }}>
                        {weatherData?.city?.name} Weather Forecast
                      </h3>
                    </div>
                  </div>
                </header>
    
                {/* This uses your existing 'weatherData' state directly */}
                {weatherData && weatherData.list ? (
                  <div className="">
                    <div style={{ display: "grid", justifyContent: "center" }}>
                      <div className="">
                        <div style={{ display: "grid", justifyContent: "center", color: "white" }}>
                          <h2 style={{ fontSize: "2rem" }}>
                            {Math.round(weatherData.list[0].main.temp)}°C
                          </h2>
                          <p>{weatherData.list[0].weather[0].description}</p>
                        </div>
                      </div>
                    </div>
    
                    <div className="custom-details" style={{ marginLeft: "15px" }}>
                      <div className="detail-item" style={{ color: "#9fb4c7" }}>
                        <i className="fas fa-tint"></i>
                        <span>Humidity: {weatherData.list[0].main.humidity}%</span>
                      </div>
                      <div className="detail-item" style={{ color: "#9fb4c7" }}>
                        <i className="fas fa-cloud-rain"></i>
                        <span>
                          Precipitation: {weatherData.list[0].pop * 100}%
                        </span>
                      </div>
                      <div className="detail-item" style={{ color: "#9fb4c7" }}>
                        <i className="fas fa-tachometer-alt"></i>
                        <span>Pressure: {weatherData.list[0].main.pressure} mb</span>
                      </div>
                      <div className="detail-item" style={{ color: "#9fb4c7" }}>
                        <i className="fas fa-wind"></i>
                        <span>Wind Speed: {(weatherData.list[0].wind.speed * 3.6).toFixed(1)} km/h</span>
                      </div>
                      <div className="detail-item" style={{ color: "#9fb4c7" }}>
                        <i className="fas fa-compass"></i>
                        <span>
                          Wind Direction: {getWindDirection(weatherData.list[0].wind.deg)} ({weatherData.list[0].wind.deg}°)
                        </span>
                      </div>
                    </div>
    
                    {/* This wraps your existing forecast component in the new layout */}
                    <div className=" ">
                      
                        <FaisalabadForcastWeahter />
                      
                    </div>
    
                  </div>
                ) : (
                  // This is the styled "No Data" UI from the other component
                  <div
                    style={{
                      display: "flex", justifyContent: "center", alignItems: "center",
                      height: "100%", color: "#9fb4c7", textAlign: "center", padding: "20px",
                    }}
                  >
                    <div
                      style={{
                        border: "1px dashed #3592fd", backgroundColor: "rgba(53, 146, 253, 0.2)",
                        borderRadius: "8px", padding: "16px", display: "flex",
                        alignItems: "center", textAlign: "justify", cursor: "pointer",
                        gap: "10px", transition: "background-color 0.3s, border-color 0.3s",
                      }}
                      onClick={handleGoBack}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "rgba(53, 146, 253, 0.3)";
                        e.currentTarget.style.borderColor = "#1e7bd7";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "rgba(53, 146, 253, 0.2)";
                        e.currentTarget.style.borderColor = "#3592fd";
                      }}
                    >
                      <HomeIcon />
                      Click to go back, draw your field, and
                      <br />
                      get the weather forecast for your field
                    </div>
                  </div>
                )}
              </Box>
            </div>
          </ThemeProvider>
        </div>
      );
};

export default WeatherWidget;
